import type { StringGUID } from "@pdfking/tfunc"
import { GuidToString, JSONHash } from "@pdfking/tfunc"

/**
 * The default identity for a plan node's payload: hash its JSON.
 *
 * This is the fallback, not the rule. It walks the whole value, so it is only
 * the right answer when that value is plain data. Anything that already knows
 * its own identity — a file, another plan — should be hashed by that identity
 * instead, which is what a task's `hash` prop is for (`Literal`, `Array`).
 * Hashing a value that embeds a plan re-serializes a tree that was already
 * hashed when it was built.
 */
export const PlanHash = (...value: unknown[]): StringGUID =>
  GuidToString(JSONHash(...(value as [unknown])))
